/**
 * The words under a web-chat reply a workflow produced (SA-474): the persona's
 * workflow binding took over the turn, so the reply has no sources and is not
 * the persona's usual answer.
 */

/** The workflow named by the stream's `chat.completion.workflow` frame. */
export interface ReplyWorkflow {
  id: string
  name: string | null
}

/** The quiet line under a workflow's reply. */
export function workflowReplyLine(name: string | null): string {
  const named = name?.trim()
  return named
    ? `Answered by the ${named} workflow, not the usual expert answer, so no sources.`
    : 'Answered by a workflow, not the usual expert answer, so no sources.'
}
